<template>
    <b-modal
      :key="id"
      v-model="shown" size="lg"
      centered no-close-on-esc no-close-on-backdrop
      class="EditorModal"
      body-class="mx-0 px-0"
      header-class="mx-0 px-0"
      footer-class="mx-0 px-0">

      <div slot="modal-header" class="px-5">
        <b-form-input id="input-large" size="lg" v-model="name" type="text" placeholder="List Name" required />
      </div>

      <div class="px-5 mb-3">
        <h4>Default segment(s)</h4>
        <segment-picker v-model="defaultSegments" />
      </div>

      <hr />

      <div class="px-5 mb-3">
        <h4>Columns to show</h4>
        <multi-select
          v-model="columns"
          placeholder="Search column"
          :options="columnOptions"
          :multiple="true"
          :taggable="false" />
      </div>

      <hr />

      <div class="px-5">
        <h4>Rank customers By</h4>
        <condition
          v-for="(condition, index) in filters"
          v-bind="condition"
          :index="index"
          :key="condition.id"
          @change="d => onFilterChange(condition.id, d)"
          @delete="onFilterDelete(condition.id)" />
      </div>


      <b-row slot="modal-footer" class="px-5">
        <b-col :cols="4">
          <b-button @click="onAddFilter" :disabled="isSaving" variant="outline-primary" class="px-5" size="md">
            Add Order Criteria
          </b-button>
        </b-col>
        <b-col :cols="8" class="text-right">
          <b-button @click="onClose" :disabled="isSaving" variant="outline" class="px-3" size="md">
            Cancel
          </b-button>
          <b-button @click="onSave" :disabled="isSaving" variant="success" class="px-3" size="md">
            <i class="fa fa-spinner fa-spin mr-2" v-if="isSaving"></i>
            Save
          </b-button>
        </b-col>
      </b-row>
    </b-modal>
</template>

<script>
  import MultiSelect from 'vue-multiselect';
  import _ from 'lodash';
  import uniqid from 'uniqid';
  import Condition from './Condition';
  import SegmentPicker from './SegmentPicker';
  import {saveList} from '../../store/lists';

  export default {
    name: 'ListEditor',
    components: {SegmentPicker, Condition, MultiSelect },

    props: {
      id: String,
    },

    data() {
      const defaults = {
        name: '',
        filters: [],
        columns: [],
        defaultSegments: [this.$store.state.segments.segmentList[0].id]
      };
      const {name, filters, columns, defaultSegments} = this.$store.getters.getList(this.id) || defaults;

      return {
        shown: true,
        isSaving: false,

        name: name,
        filters: filters,
        columns: columns,
        defaultSegments: defaultSegments
      };
    },

    computed: {
      columnOptions() {
        return _.map(this.$store.getters.customerFileColumns(true), ({name}) => name);
      }
    },

    methods: {
      onFilterChange(filterID, data) {
        const index = this.filters.findIndex(({id}) => id === filterID);
        this.filters.splice(index, 1, {...this.filters[index], ...data});
      },

      onFilterDelete(filterID) {
        this.filters = this.filters.filter(({id}) => id !== filterID);
      },

      onAddFilter() {
        this.filters.push({
          column: null,
          ascending: true,
          id: uniqid()
        });
      },

      onClose() {
        this.isSaving = false;
        this.shown = false;
        this.$emit('close');
      },

      onSave() {
        this.isSaving = true;
        const {id, name, filters, columns, defaultSegments} = this;
        const list = {id, name, filters, columns, defaultSegments};
        this.$store.dispatch(saveList(list)).then(this.onClose);
      }
    },
  };
</script>
